import { render, staticRenderFns } from "./ToolbarGroup.vue?vue&type=template&id=10570590&scoped=true"
import script from "./ToolbarGroup.vue?vue&type=script&lang=ts"
export * from "./ToolbarGroup.vue?vue&type=script&lang=ts"
import style0 from "./ToolbarGroup.vue?vue&type=style&index=0&id=10570590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10570590",
  null
  
)

export default component.exports